import styled from 'styled-components';
import Translations from 'modules/translations';
import { breakpoint, sizes } from 'variables';
import { toHtmlContent } from 'modules/helpers/strings';
import { Spacing24 } from 'autogen/design-tokens/tokens';
import { ButtonWithIcon } from 'components/Button';
import type { MessageWithQueueCallbacks } from 'components/pages/Basket/components/BasketCheckoutActions/BasketCheckoutButton/BasketCheckoutMessagesButton';
import Icon from 'components/Icon';

const Wrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: ${Spacing24};

    ${breakpoint.up(sizes.sm)} {
        padding: 20px 40px;
    }
`;

const ButtonWrapper = styled.div`
    display: flex;
    width: 100%;
    margin-top: 30px;

    & > button {
        flex: 1
    }
`;

export default ({ message }: { message: MessageWithQueueCallbacks }): JSX.Element => {
    const { messageContent, nextMessageInQueue } = message;

    return (
        <Wrapper>
            {toHtmlContent(messageContent)}
            <ButtonWrapper>
                <ButtonWithIcon
                    type="button"
                    size="lg"
                    onClick={nextMessageInQueue}
                    icon={<Icon type="ChevronRight" size={16} />}
                    iconProperties={{ position: 'right' }}
                >
                    {Translations.Website.Basket.GoToCheckout}
                </ButtonWithIcon>
            </ButtonWrapper>
        </Wrapper>
    );
};
